import {
  ScreenerSettingName,
  useIsScreenerSettingEnabled
} from '@/hooks/screener-settings';
import { useSelectedSpecificFacilityId } from '@/hooks/useFacilitiesQuery';

export const useIsBedBoardEnabled = (): boolean => {
  const facilityId = useSelectedSpecificFacilityId();

  return useIsScreenerSettingEnabled(
    ScreenerSettingName.BedBoardEnabled,
    facilityId ?? ''
  );
};
